import { DataType } from "src/app/common/models/enums/common.enum";
import { ReportTableColumn, ReportTableDropdown } from "../../models/reports.model";
import { ResidentialPrimeMenuEnum } from "./report-residential-prime.enum";

export class ReportResidentialPrimeConstants {
    static overViewMenu = [
        {
            label: 'reports.overview',
            name: ResidentialPrimeMenuEnum.overview,
        },
        {
            label: 'reports.propertyUnitSummaryTransaction',
            name: ResidentialPrimeMenuEnum.propertyUnitSummaryTransaction,
        },
        {
            label: 'reports.landTransaction',
            name: ResidentialPrimeMenuEnum.landTransaction,
        },
        {
            label: 'reports.propertyUnitSummaryRental',
            name: ResidentialPrimeMenuEnum.propertyUnitSummaryRental,
        },
        {
            label: 'reports.projectSummaryTable',
            name: ResidentialPrimeMenuEnum.projectSummaryTable,
        }
    ]
    static transactionColumns: ReportTableColumn[] = [
        {
            header: 'property_name',
            columnName: 'reports.PropertyName',
            field: 'property_name',
            isSortable: true,
            showOnMap: true,
            isAnchor: true
        },
        {
            header: 'unitType',
            columnName: 'reports.unitType',
            field: 'unitType',
            isSortable: true
        },
        {
            header: 'neighborhood',
            columnName: 'reports.neighborhood',
            field: 'neighborhood',
            isSortable: true,
            showOnMap: true,
        },
        {
            header: 'constructionStatus',
            columnName: 'reports.constructionStatus',
            field: 'constructionStatus',
            isSortable: true
        },
        {
            header: 'noOfUnits',
            columnName: 'reports.noOfUnits',
            field: 'noOfUnits',
            isSortable: true
        },
        {
            header: 'transaction_area',
            columnName: 'reports.transaction_area',
            field: 'transaction_area',
            isSortable: true,
            symbol: DataType.squareMeter,
        },
        {
            header: 'value',
            columnName: 'reports.value',
            field: 'value',
            isSortable: true,
            isContainsHTML: true,
            symbol: DataType.currencyCode
        },
        {
            header: 'transaction_rate',
            columnName: 'reports.transaction_rate',
            field: 'transaction_rate',
            isSortable: true,
            symbol: DataType.currencyWithSquareMeter,
        },
        {
            header: 'transactionType',
            columnName: 'reports.transactionType',
            field: 'transactionType',
            isSortable: true
        }
    ];
    static landColumns: ReportTableColumn[] = [
        {
            header: 'landParcelNo',
            columnName: 'reports.landParcelNo',
            field: 'landParcelNo',
            isSortable: true,
        },
        {
            header: 'neighborhood',
            columnName: 'reports.neighborhood',
            field: 'neighborhood',
            isSortable: true,
            showOnMap: true
        },
        {
            header: 'transaction_area',
            columnName: 'reports.transaction_area',
            field: 'transaction_area',
            isSortable: true,
            symbol: DataType.squareMeter
        },
        {
            header: 'value',
            columnName: 'reports.value',
            field: 'value',
            isSortable: true,
            isContainsHTML: true,
            symbol: DataType.currencyCode
        },
        {
            header: 'transaction_rate',
            columnName: 'reports.transaction_rate',
            field: 'transaction_rate',
            isSortable: true,
            symbol: DataType.currencyWithSquareMeter,
        },
        {
            header: 'transactionType',
            columnName: 'reports.transactionType',
            field: 'transactionType',
            isSortable: true
        }
    ];
    static rentalColumns: ReportTableColumn[] = [
        {
            header: 'PropertyName',
            columnName: 'reports.PropertyName',
            field: 'PropertyName',
            isSortable: true,
            showOnMap: true,
            isAnchor: true
        },
        {
            header: 'unitType',
            columnName: 'reports.unitType',
            field: 'unitType',
            isSortable: true
        },
        {
            header: 'neighborhood',
            columnName: 'reports.neighborhood',
            field: 'neighborhood',
            isSortable: true,
            showOnMap: true
        },
        {
            header: 'constructionStatus',
            columnName: 'reports.constructionStatus',
            field: 'constructionStatus',
            isSortable: true
        },
        {
            header: 'noOfUnits',
            columnName: 'reports.noOfUnits',
            field: 'noOfUnits',
            isSortable: true
        },
        {
            header: 'transaction_area',
            columnName: 'reports.transaction_area',
            field: 'transaction_area',
            isSortable: true,
            symbol: DataType.squareMeter
        },
        {
            header: 'rentalPerMonth',
            columnName: 'reports.rentalPerMonth',
            field: 'rentalPerMonth',
            isSortable: true,
            isContainsHTML: true,
            symbol: DataType.currencyCode
        },
        {
            header: 'rental_rate',
            columnName: 'reports.rental_rate',
            field: 'rental_rate',
            isSortable: true,
            symbol: DataType.currencyWithSquareMeter,
        },
        {
            header: 'rentTransactionType',
            columnName: 'reports.rentTransactionType',
            field: 'rentTransactionType',
            isSortable: true,
        }
    ];
    static projectColumns: ReportTableColumn[] = [
        {
            header: 'projectProperty',
            columnName: 'reports.projectProperty',
            field: 'projectProperty',
            isSortable: true,
            showOnMap: true,
            isAnchor: true
        },
        {
            header: 'developerName',
            columnName: 'reports.developerName',
            field: 'developerName',
            isSortable: true
        },
        {
            header: 'address',
            columnName: 'reports.address',
            field: 'address',
            isSortable: true
        },
        {
            header: 'constructionStatus',
            columnName: 'reports.constructionStatus',
            field: 'constructionStatus',
            isSortable: true
        },
        {
            header: 'totalLandArea',
            columnName: 'reports.totalLandArea',
            field: 'totalLandArea',
            isSortable: true,
            symbol: DataType.squareMeter,
        },
        {
            header: 'total_units',
            columnName: 'reports.total_units',
            field: 'total_units',
            isSortable: true
        },
        {
            header: 'builtup_area',
            columnName: 'reports.builtup_area',
            field: 'builtup_area',
            isSortable: true,
            symbol: DataType.squareMeter
        },
        {
            header: 'yob1',
            columnName: 'reports.yob1',
            field: 'yob1',
            isSortable: true,
            symbol: DataType.yr
        }
    ];
    static tableDropdown: ReportTableDropdown = {
        label: 'reports.show_price_in',
        data: [
            {
                value: 'Range',
                id: 'Range',
            },
            {
                value: 'Average',
                id: 'Average',
            },
        ],
        default: 'Range',
        maxSelect: 1,
        reportType: false,
    };
}
